import { z } from "zod";
import { UserSchema } from "../../../models/user/user";

const StaffingMonthSchema = z.object({
  available: z.object({
    total: z.number(),
    production: z.number(),
    management: z.number(),
    support: z.number(),
  }),
  staffed: z.number(),
});

const StaffingSchema = z.record(StaffingMonthSchema);

const ObjectivesSchema = z.object({
  sales: z.number(),
  billing: z.number(),
  production: z.number(),
});

// Schéma principal
export const getAllStaffingSchema = z.array(
  z.object({
    ressource: UserSchema,
    staffing: StaffingSchema,
    objectives: ObjectivesSchema,
    daily_rate: z.number(),
  })
);

export type GetAllStaffingSchemaType = z.infer<typeof getAllStaffingSchema>;